import { IconButton } from "@mui/material";
import { isIOS } from "react-device-detect";
import styled, { CSSProperties } from "styled-components";

export const Container = styled.div<{ scale: number; isMobile?: boolean }>`
	transform: scale(${(props) => props.scale});
	background-color: #fffaf1;
	border-radius: 24px;
	font-size: 13px;
	width: 34.3em;
	padding: 0.9em;
	paint-order: stroke fill;

	@media (orientation: landscape) {
		font-size: 14px;
		width: 68.1em;
		padding: 0.9em 1.9em;
	}
`;

export const Body = styled.div<{ isMobile?: boolean }>`
	margin-top: 5em;
	display: flex;
	flex-direction: column;
	gap: 1.1em;
	paint-order: stroke fill;

	@media (orientation: landscape) {
		margin-top: 3em;
	}
`;

export const Content = styled.div<{ isButton?: boolean }>`
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	gap: 1em;

	> div {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 0.2em;
	}

	@media (orientation: landscape) {
		flex-direction: ${(props) => (props.isButton ? "row-reverse" : "row")};
		width: ${(props) => (props.isButton ? "90%" : "100%")};
		margin: 0 auto;
	}
`;

export const Title = styled.p<{
	fontFamily?: string;
	fontSize?: string;
	fontWeight?: number;
	lineHeight?: string;
	color?: string;
	textAlign?: "left" | "center" | "right";
}>`
	color: ${(props) => props.color || "#113b62"};
	text-align: ${(props) => props.textAlign || "center"};
	font-family: ${(props) => props.fontFamily || "Baloo"};
	font-size: ${(props) => props.fontSize || "2.6em"};
	font-weight: ${(props) => props.fontWeight || 400};
	line-height: ${(props) => props.lineHeight || "1em"};
	margin: 0;
`;

export const SubTitle = styled.p`
	color: #fff;
	text-shadow: 0.07em 0.07em 0px #000;
	-webkit-text-stroke-width: ${isIOS ? "0.083em" : "0.2em"};
	-webkit-text-stroke-color: #000;
	font-family: Baloo;
	font-size: "1.3em";
	font-weight: 400;
	line-height: 122%;
	margin: 0;
`;

export const OfferContainer = styled.div<{
	border?: string;
	lineColor?: string;
	background?: string;
	type?: "singleItem" | "featured" | string;
}>`
	position: relative;
	background: ${(props) => props.background || "#fff"};
	border-radius: 16px;
	border: ${(props) => props.border || "0.2em solid #d9d9d9"};
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: ${(props) =>
		props.type === "singleItem" ? "0.55em 1em" : "0.9em 1em"};
	gap: ${(props) => (props.type === "singleItem" ? "1em" : "0em")};

	> div {
		display: flex;
		align-items: center;
		gap: 1em;

		> div {
			display: flex;
			flex-direction: column;
			align-items: ${(props) => (props.background ? "center" : "flex-start")};
			justify-content: ${(props) =>
				props.background ? "space-between" : "center"};
			gap: 0;
		}
	}

	div:last-child {
		&.price-crossout {
			flex-direction: column;
			gap: 0;

			span:first-child {
				position: relative;
				color: #eb5757;

				::after {
					content: "";
					display: block;
					width: 110%;
					height: 0.1em;
					background-color: #eb5757;
					position: absolute;
					top: 44%;
					left: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}

		::after {
			content: "";
			display: block;
			width: 0.1em;
			height: 100%;
			position: absolute;
			top: 0;
			right: 27%;
			background-color: ${(props) => props.lineColor || "#d9d9d9"};
		}
	}

	span {
		color: #333;
		font-family: Baloo;
		font-size: 1.6em;
		font-weight: 400;
		line-height: 100%;

		&.cross-out {
			color: #eb5757;
		}
	}

	@media (orientation: landscape) {
		padding: ${(props) =>
			props.type === "singleItem" || props.type === "featured"
				? "1.35em 1em"
				: "0.75em 1em"};
	}
`;

export const RewardDescription = styled.p`
	color: #6d6d6d;
	font-family: Inter;
	font-size: 0.9em;
	font-style: normal;
	font-weight: 700;
	line-height: 112.5%;
	margin: 0;
`;

export const FinalPrice = styled.p`
	color: #66cc32;
	text-align: center;
	paint-order: stroke fill;
	text-shadow: 0px 0.091em 0.1365em rgba(0, 0, 0, 0.35);
	-webkit-text-stroke-width: ${isIOS ? "0.091em" : "0.18em"};
	-webkit-text-stroke-color: #fff;
	font-family: Baloo;
	font-size: 2.2em;
	font-weight: 400;
	line-height: 109.091%;
	margin: 0;
`;

export const ContributeToPB = styled.p`
	color: #fff;
	text-align: center;
	text-shadow: 0px 0.1em 0px #000;
	-webkit-text-stroke-width: ${isIOS ? "0.1em" : "0.25em"};
	-webkit-text-stroke-color: #000;
	font-family: Baloo;
	font-size: 1.5em;
	font-weight: 400;
	margin: 0;
`;

export const InfoButton = styled(IconButton)`
	position: absolute;
	top: 0;
	right: 27%;
	background: none;
	border: none;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
`;

export const bannerStyle: CSSProperties = {
	height: "3.2em",
	display: "flex",
	alignItems: "center",
	borderTopRightRadius: "24px"
};

export const textStyle: CSSProperties = {
	fontSize: "1.61em",
	borderTopRightRadius: "24px",
	fontFamily: "Baloo",
	fontWeight: 400
};
